export default "/images/vendor/flag-icon-css/flags/1x1/sk.svg?563985765998ec7428e99bda01cbee7c";